<template>
  <div class="wrap">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <template v-if="flowInfoIng.code === 'H999001' || flowInfoIng.code === 'H999002'">
        <el-tab-pane :label="formModal.flowname">
          <div v-for="(item, index) in config" :key="index">
            <sqb-form
              readme="applicantTable-1"
              ref="sqbForm"
              v-if="config[index] && flowInfoIng.index"
              :formData="formModal.children[index]"
              :flowname="formModal.flowname"
              :configs="config[index].config"
              :disabled="false"
              @getProcessData="getProcessData"
              :getAllTableColumnConfig="getAllTableColumnConfig"
              :flowindex="index"
            ></sqb-form>
          </div>
          <div v-for="(item, index) in config" :key="index + '1'">
            <sqb-form-qlxx
              readme="applicantTable-2"
              ref="sqbForm"
              v-if="config[index] && flowInfoIng.index"
              :formData="formModal.children[index]"
              :flowname="formModal.flowname"
              :configs="config[index].config"
              :disabled="false"
              @getProcessData="getProcessData"
              :getAllTableColumnConfig="getAllTableColumnConfig"
              :flowindex="index"
            ></sqb-form-qlxx>
          </div>
        </el-tab-pane>
      </template>
      <el-tab-pane v-else v-for="(item, index) in config" :key="index" :label="item.name" :name="index + ''">
        <sqb-form
          readme="applicantTable-3"
          ref="sqbForm"
          v-if="config[index] && flowInfoIng.index"
          :formData="formModal.children[index]"
          :flowname="formModal.flowname"
          :configs="config[index].config"
          :disabled="false"
          @getProcessData="getProcessData"
          :getAllTableColumnConfig="getAllTableColumnConfig"
          :flowindex="index"
        ></sqb-form>
        <sqb-form-qlxx
          readme="applicantTable-4"
          ref="sqbForm"
          v-if="config[index] && flowInfoIng.index"
          :formData="formModal.children[index]"
          :flowname="formModal.flowname"
          :configs="config[index].config"
          :disabled="false"
          @getProcessData="getProcessData"
          :getAllTableColumnConfig="getAllTableColumnConfig"
          :flowindex="index"
        ></sqb-form-qlxx>
      </el-tab-pane>
    </el-tabs>
    <div class="footer text-center">
      <el-button type="primary" @click="prev()" v-show="isNextBtnShow">上一步</el-button>
      <el-button type="primary" @click="validatorForm('saveApplyData')">保 存</el-button>
      <el-button type="primary" @click="validatorForm('next')">下一步</el-button>
    </div>
  </div>
</template>
<script>
import applicantSaveService from '@/pages/iebdc/api/apply/applicant-save';
import applicantQlxxService from '@/pages/iebdc/api/apply/applicant-qlxx';
import applicantSqrService from '@/pages/iebdc/api/apply/applicant-sqr';
import { mapMutations, mapState } from 'vuex';
import processInfo from '@iebdc/mixin/getProcessInfo';
import { localDataUser } from '@iebdc/utils/local-data';
import { lastDayOfMonth } from 'date-fns';

export default {
  name: 'applicantTable',
  mixins: [processInfo],
  computed: {
    // 下一步跳转所需数据
    ...mapState('wysq-step', ['nextItem']),
    // 我要申请流程数据
    ...mapState('wysq-data', ['flowInfoIng']),
    // 表单数据
    ...mapState('wysq-data', ['processData']),
    // 申请弹窗的title数据
    getAllTableColumnConfig() {
      const allTableColumnConfig = [];
      this.config.map((singleFlowConfig) => {
        singleFlowConfig.config.map((item) => {
          if (item.formConfig) {
            allTableColumnConfig.push(item.tableTitle);
          }
        });
      });
      console.log('【步骤？】 config', this.config);
      return [...new Set(allTableColumnConfig)];
    },
  },
  data() {
    return {
      activeName: '0',
      isNextBtnShow: false, //上一步按钮是否显示
      userInfo: localDataUser.get(), //当前用户信息
      isFamilyGroupNull: false, //家庭组验证
      qlrsFamilyListData: [], //权利人家庭组验证
      ywrsFamilyListData: [], //义务人家庭组验证
    };
  },
  methods: {
    // /**
    //  * @desc vuex共用方法
    //  * */
    // // 更新流程信息
    ...mapMutations('wysq-data', ['setFlowInfoIng']),
    //设置表单指
    ...mapMutations('wysq-data', ['setFormData']),
    // 跳转到上一页面
    prev() {
      this.targetToStep('产权证核验');
      this.$router.push({
        name: 'rightCertify',
        params: { ywh: this.flowInfoIng.wwywh },
      });
    },
    // 跳转到下一页面
    ...mapMutations('wysq-step', ['targetToStep']),
    /**
     * @desc 获取数据
     * */
    //根据ywh获取流程数据
    getProcessData() {
      applicantSaveService.getProcessInfo({ wwywh: this.flowInfoIng.wwywh }).then((res) => {
        if (res.success) {
          applicantQlxxService.setQlxxEx(res.data);
          res.data.children = res.data.children || [{}];
          res.data.children.forEach((item, pindex) => {
            this.processData.forEach((pitem, index) => {
              if (pindex === index) {
                for (let key in item) {
                  if (key === 'qlxxExMhs' && res.data.sqrlx === 'NORMAL') {
                    item[key] = pitem[key] ? pitem[key] : item[key];
                  } else if (key !== 'qlrs' && key !== 'ywrs' && key !== 'qlxxExMhs') {
                    item[key] = pitem[key] ? pitem[key] : item[key];
                  }
                }
              }
            });
          });
          this.setFormData(res.data.children);
          this.formModal = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 保存申请数据
    async saveApplyData() {
      if (this.processData.length > 0) {
        let tzrList = this.getSqrXx(this.processData);
        //合并流程
        let hblc = this.flowInfoIng.code === 'H999001' || this.flowInfoIng.code === 'H999002';
        if (hblc) {
          this.processData[1].qlxxExMhs = this.processData[0].qlxxExMhs;
        }
        let obj = JSON.parse(JSON.stringify(this.processData));
        console.log(obj);
        if (obj.length)
          obj.forEach((item, index) => {
            obj[index].tzrxxes = tzrList[index];
            item.qlxxExMhs.forEach((ele) => {
              if (ele.bdcdjzmh) {
                item.bdcdjzmh = ele.bdcdjzmh;
              }
            });
          });

        const params = {
          wwywh: this.flowInfoIng.wwywh,
          qlxxChildDtoList: obj,
        };
        const { success, message } = await applicantSaveService.modifyProcessInfo(params);
        if (success) {
          this.$message.success('保存成功');
        } else {
          this.$message.error('保存失败');
        }
      }
    },
    /*
     * @desc 获取所有的权利人或者义务人信息
     * @params data为processData流程数据
     * @params singleList为每一项所保存数据用的数组
     * @params tzrList为整个通知人对象集合
     */
    getSqrXx(data) {
      let copyData = JSON.parse(JSON.stringify(data));
      let tzrList = [];
      // 不需要通知人的流程在这里进行添加
      // N100201---预售商品房买卖预告登记
      // N100203---预售商品房抵押预告登记
      // H999001---双预告
      const lcCode = ['N100201', 'N100203', 'H999001'];
      // 先判断是否有数据
      if (copyData.length > 0) {
        for (let i = 0; i < copyData.length; i++) {
          // 预告登记只通知预告权利人
          let singleList = [];
          if (copyData[i].qlrs) {
            for (let j = 0; j < copyData[i].qlrs.length; j++) {
              singleList.push(copyData[i].qlrs[j]);
            }
          }
          // 除去预告流程lcCode的义务人
          if (copyData[i].ywrs && !lcCode.includes(this.flowInfoIng.code)) {
            for (let j = 0; j < copyData[i].ywrs.length; j++) {
              singleList.push(copyData[i].ywrs[j]);
            }
          }
          tzrList.push(this.handleTzrxx(singleList));
        }
      }
      return tzrList;
    },
    /*
     * @desc 处理通知人信息
     */
    handleTzrxx(data) {
      let tzrxxes = [];
      const needKey = ['bz', 'category', 'dzyx', 'tzdh', 'tzfs', 'tzrmc'];
      for (let j = 0; j < data.length; j++) {
        let needObj = {};
        needKey.forEach((key, index) => {
          if (key === 'tzdh') {
            needObj[key] = data[j]['dh'];
          } else if (key === 'tzrmc') {
            needObj[key] = data[j]['qlrmc'] || data[j]['ywrmc'];
          } else {
            needObj[key] = data[j][key];
          }
        });
        tzrxxes.push(needObj);
      }
      return tzrxxes;
    },
    /**
     *  @desc 路由行为
     * */
    // 跳转到下一页面
    next() {
      this.targetToStep('填写申请表');
      this.$confirm('请确认信息是否真实有效？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.saveApplyData().then(() => {
            this.$router.push({
              name: this.nextItem.name,
            });
          });
        })
        .catch(() => {
          this.$message({
            type: 'warning',
            message: '请准确填写相关信息！',
          });
        });
    },
    //家庭组验证添加到对应数组
    familyGroupListDataFnc() {
      this.qlrsFamilyListData = [];
      this.ywrsFamilyListData = [];
      this.formModal.children.forEach((item) => {
        //不验证转本位的-2业务
        if (
          (item.ywh.charAt(item.ywh.length - 2) == '-' && item.ywh.charAt(item.ywh.length - 1) == 1) ||
          item.ywh.charAt(item.ywh.length - 2) != '-'
        ) {
          //权利人
          item.qlrs.forEach((itemqlrsChild) => {
            if (Number(itemqlrsChild.qlrlx) == 1) {
              if (Number(itemqlrsChild.gyfs) != 0) {
                if (
                  itemqlrsChild.familyGroup &&
                  itemqlrsChild.familyGroup.hasOwnProperty('familyMemberList') &&
                  itemqlrsChild.familyGroup.familyMemberList &&
                  itemqlrsChild.familyGroup.familyMemberList.length > 0
                ) {
                  itemqlrsChild.familyGroup.familyMemberList.map((qlrFamilyMemberListItem) => {
                    this.qlrsFamilyListData.push(qlrFamilyMemberListItem.zjh);
                  });
                }
              }
            }
          });
          //义务人
          item.ywrs.forEach((itemywrsChild) => {
            if (Number(itemywrsChild.qlrlx) == 1) {
              if (Number(itemywrsChild.gyfs) != 0) {
                if (
                  itemywrsChild.familyGroup &&
                  itemywrsChild.familyGroup.hasOwnProperty('familyMemberList') &&
                  itemywrsChild.familyGroup.familyMemberList &&
                  itemywrsChild.familyGroup.familyMemberList.length > 0
                ) {
                  itemywrsChild.familyGroup.familyMemberList.map((ywrFamilyMemberListItem) => {
                    this.ywrsFamilyListData.push(ywrFamilyMemberListItem.zjh);
                  });
                }
              }
            }
          });
        }
      });
    },
    // /** 工具函数
    //  * */
    // 校验当前页面信息
    validatorForm(funcName) {
      //判断转移登记家庭组是否为空
      if (this.formModal.netFlowdefCode == 'N200104' || this.formModal.netFlowdefCode == 'H999002') {
        this.isFamilyGroupNull = false;
        this.familyGroupListDataFnc();
        try {
          this.formModal.children.forEach((item) => {
            //不验证转本位的-2业务
            if (
              (item.ywh.charAt(item.ywh.length - 2) == '-' && item.ywh.charAt(item.ywh.length - 1) == 1) ||
              item.ywh.charAt(item.ywh.length - 2) != '-'
            ) {
              item.qlrs.forEach((itemqlrsChild) => {
                if (Number(itemqlrsChild.qlrlx) == 1) {
                  //共有方式为单独所有的处理方式
                  if (Number(itemqlrsChild.gyfs) == 0) {
                    if (
                      itemqlrsChild.familyGroup == null ||
                      !itemqlrsChild.familyGroup.familyMemberList ||
                      itemqlrsChild.familyGroup.familyMemberList.length === 0
                    ) {
                      this.$message.error(`请确认${itemqlrsChild.qlrmc}添加了家庭组`);
                      this.isFamilyGroupNull = true;
                      throw new Error(false);
                    }

                    if (itemqlrsChild.familyGroup.houseNumber == null && this.formModal.netFlowdefCode != 'H999002') {
                      this.$message.error(`请填写${itemqlrsChild.qlrmc}的家庭组房屋套数`);
                      this.isFamilyGroupNull = true;
                      throw new Error(false);
                    }
                  } else {
                    //共有方式不为单独所有的处理方式
                    for (let index = 0; index < this.qlrsFamilyListData.length; index++) {
                      if (this.qlrsFamilyListData[index] == itemqlrsChild.zjh) {
                        this.$set(itemqlrsChild, 'isFamilyGroupNull', false);
                        break;
                      } else {
                        this.$set(itemqlrsChild, 'isFamilyGroupNull', true);
                      }
                    }
                    if (this.qlrsFamilyListData.length == 0) {
                      this.$set(itemqlrsChild, 'isFamilyGroupNull', true);
                    }
                    if (itemqlrsChild.isFamilyGroupNull) {
                      this.$message.error(`请确认${itemqlrsChild.qlrmc}添加了家庭组`);
                      this.isFamilyGroupNull = true;
                      throw new Error(false);
                    }
                    //家庭房屋套数验证
                    if (
                      itemqlrsChild.familyGroup &&
                      itemqlrsChild.familyGroup.hasOwnProperty('houseNumber') &&
                      ((!itemqlrsChild.familyGroup.houseNumber && itemqlrsChild.familyGroup.houseNumber != 0) ||
                        itemqlrsChild.familyGroup.houseNumber === '')
                    ) {
                      this.$message.error(`请填写${itemqlrsChild.qlrmc}的家庭组房屋套数`);
                      this.isFamilyGroupNull = true;
                      throw new Error(false);
                    }
                  }
                }
              });
              //义务人
              item.ywrs.forEach((itemChild) => {
                if (Number(itemChild.qlrlx) == 1) {
                  //共有方式为单独所有的处理方式
                  if (Number(itemChild.gyfs) == 0) {
                    if (
                      itemChild.familyGroup == null ||
                      !itemChild.familyGroup.familyMemberList ||
                      itemChild.familyGroup.familyMemberList.length === 0
                    ) {
                      this.$message.error(`请确认${itemChild.ywrmc}添加了家庭组`);
                      this.isFamilyGroupNull = true;
                      throw new Error(false);
                    }

                    if (
                      (!itemChild.familyGroup.houseNumber || itemChild.familyGroup.houseNumber < 0) &&
                      this.formModal.netFlowdefCode != 'H999002'
                    ) {
                      this.$message.error(`请填写${itemChild.ywrmc}的家庭组房屋套数`);
                      this.isFamilyGroupNull = true;
                      throw new Error(false);
                    }
                  } else {
                    //共有方式不为单独所有的处理方式
                    for (let index = 0; index < this.ywrsFamilyListData.length; index++) {
                      if (this.ywrsFamilyListData[index] == itemChild.zjh) {
                        this.$set(itemChild, 'isFamilyGroupNull', false);
                        break;
                      } else {
                        this.$set(itemChild, 'isFamilyGroupNull', true);
                      }
                    }
                    if (this.ywrsFamilyListData.length == 0) {
                      this.$set(itemChild, 'isFamilyGroupNull', true);
                    }
                    if (itemChild.isFamilyGroupNull) {
                      this.$message.error(`请确认${itemChild.ywrmc}添加了家庭组`);
                      this.isFamilyGroupNull = true;
                      throw new Error(false);
                    }
                    //家庭房屋套数验证
                    console.log(
                      itemChild.familyGroup &&
                        itemChild.familyGroup.hasOwnProperty('houseNumber') &&
                        !itemChild.familyGroup.houseNumber
                    );
                    if (
                      itemChild.familyGroup &&
                      itemChild.familyGroup.hasOwnProperty('houseNumber') &&
                      !itemChild.familyGroup.houseNumber
                    ) {
                      this.$message.error(`请填写${itemChild.ywrmc}的家庭组房屋套数`);
                      this.isFamilyGroupNull = true;
                      throw new Error(false);
                    }
                  }
                }
              });
            }
          });
          // this.processData.forEach((item) => {
          //   if (Number(item.ycxx.sfba) == 1 && item.ycxx.bahtbh == '') {
          //     this.$message.error('请填写备案合同号');
          //     isFamilyGroupNull = true;
          //     throw new Error(false);
          //   }
          //   if (Number(item.ycxx.sfws) == 1 && item.ycxx.wspzh == '') {
          //     this.$message.error('请填写完税凭证号');
          //     isFamilyGroupNull = true;
          //     throw new Error(false);
          //   }
          // });
        } catch (e) {
          return false;
        }
        if (this.isFamilyGroupNull) {
          this.$message.error('请确认表单');
          return false;
        }
      }
      //判断是否所有申请人表格填写完成
      const sqrTableValidator = new Promise((resolve, reject) => {
        const message = applicantSqrService.sqrTableValidate(this.formModal, this.config);
        if (message) {
          reject(message);
        }
        resolve();
      });
      //判断不动产权信息是否填写完成
      const qlxxTableValidator = new Promise((resolve, reject) => {
        const message = applicantQlxxService.qlxxTableValidate(this.formModal, this.config);
        if (message) {
          reject(message);
        }
        resolve();
      });

      //权利信息扩展表单校验
      const qlxxValidator = new Promise((resolve, reject) => {
        let num = 0;

        this.$refs.sqbForm.forEach((item) => {
          (item.$refs.qlxx || []).forEach((form) => {
            form.$refs.form.validate((valid) => {
              if (!valid) {
                num++;
              }
            });
          });
          if (num > 0) {
            reject('请完善不动产申请信息');
            return;
          }
        });
        resolve();
      });

      //通知人表单验证
      // const tzrValidator = new Promise((resolve, reject) => {
      //   let num = 0;
      // this.$refs.sqbForm.forEach((item) => {
      //   item.$refs.sqr.forEach((form) => {
      //     form.$refs.form.$refs.form.validate((valid) => {
      //       if (!valid) {
      //         num++;
      //       }
      //     });
      //   });
      //   if (num > 0) {
      //     reject('请完善通知人信息');
      //     return;
      //   }
      // });
      //   resolve();
      // });
      //校验内容
      let valid = [];
      if (this.flowInfoIng.sqrlx === 'NORMAL') {
        valid = [qlxxValidator, sqrTableValidator];
      } else {
        valid = [qlxxValidator, qlxxTableValidator, sqrTableValidator];
      }
      // //校验开始
      Promise.all(valid)
        .then(() => {
          // 校验成功,调用相应方法
          this[funcName]();
        })
        .catch((message) => {
          this.$message.error(message);
        });
    },
    //切换表单
    handleClick() {
      // 需要更新的数据对象
      let params = Object.assign({}, this.flowInfoIng);
      params.ywh = this.formModal.ywh[this.activeName];
      params.index = this.activeName;
      // 调用vuex，更新数据对象
      this.setFlowInfoIng(params);
    },
    //更新流程中数据
    updateFlowInfoIng(data) {
      // 需要更新的数据对象
      const params = {
        id: data.id,
        wwywh: data.wwywh,
        ywh: data.ywh[this.activeName],
        index: this.activeName,
        subcode: data.subFlowcode,
        subname: data.subFlowname,
        code: data.netFlowdefCode,
        sqrlx: data.sqrlx,
      };
      // 调用vuex，更新数据对象
      this.setFlowInfoIng(params);
      this.setFormData(data.children);
    },
  },
  mounted() {},
  created() {
    this.setFlowInfoIng({});
    this.setFormData([]);
    let ywhLocal = localStorage.getItem('ywh');
    let ywh = this.$route.params.ywh ? this.$route.params.ywh : ywhLocal;
    this.isNextBtnShow = this.$route.params.isNextBtnShow ? this.$route.params.isNextBtnShow : false;
    // 获取流程数据
    Promise.all([this.getProcessInfo(ywh)])
      .then((res) => {
        console.log('开始获取流程信息');
        this.updateFlowInfoIng(this.formModal);
        let code = this.formModal.netFlowdefCode;
        let name = this.formModal.subFlowname;
        this.$store.commit('wysq-step/getStepList', {
          currentSelectedFlowCode: code,
          currentSelectedName: name,
        });
        this.targetToStep('填写申请表');
      })
      .catch(() => {
        this.$message.error('获取数据失败');
      });
  },
};
</script>

<style scoped lang="scss">
@import 'src/styles/common-variables';

.wrap {
  border-radius: $border-radius-base;
  background-color: $background-color-layout;
  .footer {
    margin-top: $spacing-large;
  }
}
</style>
